// src/components/titlebar/components/ZoomControls.tsx

import React from "react"
import AppTooltip from "@shared/components/tooltip/AppTooltip"
import { tooltipTitleByKey } from "@shared/components/tooltip/tooltipRegistry"

import { ZoomIn as ZoomInIcon, ZoomOut as ZoomOutIcon } from "@mui/icons-material"
import { ZoomControlsContainer, ZoomButton } from "../styles/titleBarStyles"
import type { ZoomControlsProps } from "../types/titleBarTypes"

const ZoomControls: React.FC<ZoomControlsProps> = ({ onZoomIn, onZoomOut }) => {
  return (
    <ZoomControlsContainer>
      <AppTooltip title={tooltipTitleByKey("common.zoomIn")} placement="bottom">
        <ZoomButton onClick={onZoomIn}>
          <ZoomInIcon />
        </ZoomButton>
      </AppTooltip>
      <AppTooltip title={tooltipTitleByKey("common.zoomOut")} placement="bottom">
        <ZoomButton onClick={onZoomOut}>
          <ZoomOutIcon />
        </ZoomButton>
      </AppTooltip>
    </ZoomControlsContainer>
  )
}

export default ZoomControls
